import '@hotwired/turbo-rails';

document.addEventListener('turbo:before-render', () => {
  document.getElementsByTagName('html')[0].classList.remove('no-scroll');
});
